///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Namespaces
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp = abcsetup.consumer_rfp || {};
abcsetup.consumer_rfp.bids = abcsetup.consumer_rfp.bids || {};


///////////////////////////////////////////////////////////////////////////////////////////////////
//
//  Methods
//
///////////////////////////////////////////////////////////////////////////////////////////////////
abcsetup.consumer_rfp.bids.edit = {
    upload_init: false,
    fields_init: false,
    init_items: false,
    custom_fields_instances: {},

    init() {
        abcsetup.setTitle('Consumer RFP Bids');

        this._setupEventBindings();
        this._setupCustomFields();
        this._toggleSupplierQuestions();
        this._toggleAuditHistoryQuestion();
    },

    _checkForLowestQuote(consumerRFPId, onConfirm) {
        const hasPlacedBid = consumerRFPItemId => String($(`[name=item_${consumerRFPItemId}_place_bid]`).val()) === '1';

        const supplierQuotes = $('.item-accordion .bid-item .card-body').toArray()
            .reduce((result, itemCardBody) => ({
                ...result,
                [$(itemCardBody).parent().attr('id')]: hasPlacedBid($(itemCardBody).parent().attr('id'))
                    ? $(`[name=item_${$(itemCardBody).parent().attr('id')}_supplier_quote]`).val()
                    : null,
            }), {});

        axios.get(`/api/consumer_rfp/${consumerRFPId}/bids/lowest_quotes?exclude_org_id=${abcsetup.userOrg.id}`)
            .then(({ data }) => {
                const lowerBids = data.map(bidInfo => {
                    if (!supplierQuotes[bidInfo['consumer_rfp_item_id']]) {
                        // Supplier is not bidding on this item.
                        return null;
                    } else if (Number(supplierQuotes[bidInfo['consumer_rfp_item_id']]) <= Number(bidInfo['min_supplier_quote'])) {
                        // Supplier's quote is less-than-or-equal-to the minimum quote for this item.
                        return null;
                    }

                    // Supplier's quote is greater than the minimum quote for this item.
                    return bidInfo;
                }).filter(Boolean);

                if (lowerBids.length === 0) {
                    onConfirm();
                } else {
                    abcsetup.alerts.confirm(
                        'Not Lowest Bid',
                        `<p>These items have lower bids placed already. Would you like to continue with submitting your bids?</p>
                                    <table class="table">
                                    <tr><th>Item</th></tr>
                                    ${lowerBids.map(lowerBid => `<tr><td>${lowerBid['mat_descr']}</td></tr>`).join('')}
                                    </table>`,
                        confirmed => confirmed && onConfirm()
                    );
                }
            });
    },

    _setupEventBindings() {
        // Accordion item clicked
        $('[data-toggle="collapse"]').off('click.accordion_item').on('click.accordion_item', function () {
            $('.item-accordion').data('item', $($(this).attr('href')).attr('id'));
        });

        // Accordion open/closed
        $(document).on('show.bs.collapse', '.collapse', function () {
            $(this).parent().find('.fa').removeClass('fa-chevron-up').addClass('fa-chevron-down');

            if (!$(this).parent().find('.card-header').hasClass('list-group-item-success')) {
                $(this).parent().find('.card-header').addClass('list-group-item-primary');
            }
        }).on('hide.bs.collapse', '.collapse', function (event) {
            $(this).parent().find('.fa').removeClass('fa-chevron-down').addClass('fa-chevron-up');
            $(this).parent().find('.card-header').removeClass('list-group-item-primary');
        });

        // Validate button
        $(document).on(
            'click',
            '.card .btn.validate-item',
            ({ target: validateButton }) => this._validateItem($(validateButton).closest('.card-body'))
        );

        // Save
        $(document).on('click', '.btn-save', () => this._syncCustomFieldsUserData());

        // Submit
        $(document).on(
            'click',
            '.btn-submit',
            event => {
                const consumerRfpBidsForm = $('.consumer_rfp_bids_form');
                const consumerRFPId = consumerRfpBidsForm.data('consumerRfpId');

                this._syncCustomFieldsUserData();

                const isValid = $('form.consumer_rfp_bids_form .card.bid-item .card-body')
                    .toArray()
                    .reduce((result, itemPanel) => result && this._validateItem(itemPanel, false, true), true);

                if (!isValid) {
                    return false;
                }

                if (!consumerRfpBidsForm.data('checkForLowestQuote')) {
                    return true;
                }

                $(event.target.form).append("<input type='hidden' name='form_action' value='submit'/>");
                this._checkForLowestQuote(consumerRFPId, () => event.target.form.submit());

                return false;
            }
        )
    },

    /**
     * Validate the item form
     *
     * @param itemPanel
     * @param init
     * @param submitting
     */
    _validateItem(itemPanel, init = false, submitting = false) {
        const itemCard = $(itemPanel).closest('.card');
        const itemCardHeader = itemCard.find('.card-header');
        const itemCardCollapse = itemCard.find('.collapse');
        fieldValidate.removeOrnaments(itemCard.find(':input'));
        const valid = fieldValidate.checkValidity(itemCard.find(':input'));

        if (valid) {
            if (!init) {
                itemCardCollapse.collapse('hide');
                if (!submitting) {
                    abcsetup.alerts.show('Item Validation', 'The item has passed validation');
                }
            }

            this._setItemHeaderStyles(itemPanel);
        } else {
            this._setItemHeaderStyles(itemPanel);

            if (submitting) {
                itemCardCollapse.collapse('show');
                itemCardHeader.addClass('list-group-item-primary');
            }
        }

        if (init) {
            fieldValidate.removeOrnaments(itemCard.find(':input'));
        }

        return valid;
    },

    _setItemHeaderStyles(itemPanel) {
        const itemCard = $(itemPanel).closest('.card');
        const itemCardHeader = itemCard.find('.card-header');

        if (itemCard.find(':input[name$=place_bid]').val() === '0') {
            // Ignored (when ignored, we don't need any other fields to be filled in).
            itemCardHeader.addClass('list-group-item-success ignored');
            itemCard.find('h5.title i:first').replaceWith('<i class="fas fa-eye-slash"></i>');
        } else if (itemCard.find('.invalid').length) {
            // Invalid
            itemCardHeader.removeClass('list-group-item-success ignored');
            itemCard.find('h5.title i:first').replaceWith('<i class=""></i>');
        } else {
            // Valid
            itemCardHeader.addClass('list-group-item-success').removeClass('ignored');
            itemCard.find('h5.title i:first').replaceWith('<i class="fas fa-check"></i>');
        }
    },

    _validateAllItems() {
        $('.card.bid-item .card-body:has(.btn.validate-item)')
            .toArray()
            .forEach(itemPanel => this._validateItem(itemPanel, true));

        this.init_items = true;
    },

    /*
    * _jquery.fieldValidate
    *       Fields have been init - this is the callback
    */
    fieldsInit() {
        this.fields_init = true;

        // Update the item states (after fields and uploads have been init)
        if (this.upload_init) {
            this._validateAllItems();
        }
    },

    /**
     * _jquery.uploader
     *      Uploader attachment buttons and values have been init
     */
    uploadInit() {
        this.upload_init = true;

        // Update the item states (after fields and uploads have been init)
        if (this.fields_init) {
            this._validateAllItems();
        }
    },

    /*
    * _jquery.fieldValidate
    *       A field is invalid.
    */
    fieldError() {
        $('.consumer_rfp_bids_form .invalid:visible').first().focus();
    },

    /**
     * _jquery.uploader
     *      An upload is complete this is the callback
     */
    uploadDone() {
        if (abcsetup.uploader.uploadResult.consumer_rfp_id) {
            let msg = '';

            $('.item-accordion, .item_attachments, .btn-attach').hide();
            $('.control-buttons').parent().hide();

            if (abcsetup.uploader.uploadResult.success) {
                msg += 'Items successfully imported'; // success is always returned. We'll get a validation exception when something goes wrong.
            }

            abcsetup.alerts.show('Item Imports', msg, function () {
                abcsetup.blockUI(true);
                window.location.assign('/consumer_rfp/' + abcsetup.uploader.uploadResult.consumer_rfp_id + '/bids');
            });
        }
    },

    /**
     * Render the custom fields and setup references to them for future interaction.
     * @private
     */
    _setupCustomFields() {
        $('.custom_fields').toArray().forEach(container => {
            const consumerRFPItemId = $(container).closest('.bid-item').data('consumerRfpItemId');
            const customFieldsUserData = JSON.parse($(`[name=custom_field_user_data\\[${consumerRFPItemId}\\]]`).val());
            this.custom_fields_instances[consumerRFPItemId] = $(container).formRender({
                formData: customFieldsUserData && customFieldsUserData.length > 0 ? customFieldsUserData : $(container).data('formData'),
            });
        });
    },

    /**
     * Get the user data from each of the rendered fields and put it in a form field.
     * @private
     */
    _syncCustomFieldsUserData() {
        Object.keys(this.custom_fields_instances).forEach(consumerRFPItemId => {
            $(`[name=custom_field_user_data\\[${consumerRFPItemId}\\]]`).val(
                JSON.stringify(this.custom_fields_instances[consumerRFPItemId].userData)
            );
        });
    },

    /**
     * Conditional Logic for supplier questions to display if the supplier is placing a bid for at least one of the items
     */

    _toggleSupplierQuestions: function () {

        $(document).on('change', 'select[name*="place_bid"]', function () {
            if ($('select[name*="place_bid"] option:selected[value="1"]').length) {
                $('#supplier_questions').show();
                $('input[name="facility_last_audited"]').attr('disabled', false);  
            } else {
                $('#supplier_questions').hide();
                // Hack to remove the validation so that the page can be submitted when the 
                // supplier chooses not to participate.
                $('input[name="facility_last_audited"]').attr('disabled', true); 
            }
        });

        $("select[name*='place_bid']").trigger('change');
    },

    /**
     * Conditional Logic for supplier questions to display if the supplier is placing a bid for at least one of the items
     */

    _toggleAuditHistoryQuestion: function () {

        $(document).on('change', 'input[name*="audit_history"]', function () {
            if ($('#audit_history').is(":checked")) {
                $('#audit_history').val(1);
                $('#div_facility_last_audited').removeClass("required");
                $('#facility_last_audited').removeClass("invalid").attr("required", false);
                $('#facility_last_audited').next('.errorMsg').remove();
            } else {
                $('#audit_history').val(0);
                $('#div_facility_last_audited').addClass("required");
                $('#facility_last_audited').attr("required", true);
            }
        });

        $("input[name*='audit_history']").trigger('change');
    }
}
